var map = {
	"./fubon/pages/Trade/Trade": 30749,
	"./scb/pages/Trade/Trade": 80689,
	"./ttl/pages/Trade/Trade": 22405
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 21914;
module.exports = webpackAsyncContext;